import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import food from './images/food.png';
import check from './images/check.png';
import Button from '../../components/form-elements/button';
import Header from '../../components/header/header';
import AppRoutes from '../../constants/AppRoutes';
import Messages from '../../constants/Messages';

const OrderConfirmation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [items, setItems] = useState();

    useEffect(() => {
        if(!state) {
            // If the request is not coming from cart page after payment, navigate to home.
            navigate(AppRoutes.HOME);
        } else {
            setItems(JSON.parse(state.items));
        }
    }, []);
    
    /** ------------------------------------------
     * Method : backToShop
     * Description : Navigate back to shop page
     */
    const backToShop = () => {
        navigate(AppRoutes.HOME);
    };

    return (
        <div className='bg-gray-100'>
            <Header title = "Order Confirmed"/>
            <div className='mx-auto max-w-lg min-h-screen pb-20'>
                <div className='w-2/3 flex justify-center mx-auto p-10 pb-0'>
                    <img src = {food}/>
                </div>
                <div className='container p-4 mx-auto'>
                    <div className='text-center'>
                        <h1 className='font-bold'>
                            {Messages.ORDER_CONFIRMATION.PAYMENT_SUCCESSFUL}
                        </h1>
                        <h1 className='text-6xl p-4 pt-2'>
                            <span className='text-2xl '>{Messages.CURRENCY.INR} </span>
                            {state?.amountPaid}
                        </h1>
                        <div className='rounded-lg border bg-white mb-4 text-sm'>
                            <h1 className='p-2 font-bold' >{Messages.ORDER_CONFIRMATION.ORDER_SUMMARY}</h1>
                            <ul>
                                {
                                    items && items.length > 0 ? items.map(item => {
                                        return (
                                            <li className='flex  p-4 border-t' key = {item.id}>
                                                <span className='basis-2/3 text-left'>{item.name} (x {item.quantity})</span>
                                                <span className='basis-1/3 text-right'>{Messages.CURRENCY.INR} { Number(item.quantity) * Number(item.price)}</span>
                                            </li>
                                        )
                                    }) : null
                                }
                            </ul>
                        </div>
                        <p className='text-sm font-bold'>{Messages.ORDER_CONFIRMATION.COLLECT_FOOD_MESSAGE}</p>
                    </div>
                    
                    <div className='fixed bottom-0 inset-x-0 mx-auto max-w-lg w-full p-4'>
                        <Button onClick = {backToShop}>{Messages.CART.BACK_TO_SHOP}</Button>
                    </div>
                </div>
            </div>  
        </div>
    )
}

export default OrderConfirmation;





